import { render, staticRenderFns } from "./WallTabsWrap.vue?vue&type=template&id=3cd0edff&"
import script from "./WallTabsWrap.vue?vue&type=script&lang=js&"
export * from "./WallTabsWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports